module.exports = __webpack_public_path__ + "static/img/workerconstruct.5c7a854.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workerconstruct.jpeg
// module id = h1e4
// module chunks = 73